import {
  Alert,
  ColumnLayout,
  ContentLayout,
  ExpandableSection,
  Grid,
  Header,
  SpaceBetween,
} from '@cloudscape-design/components';
import { formatDuration } from 'features/plc/components/common';
import PLCButton from 'features/plc/components/PLCButton';
import {
  PLC_PATHS,
  PRESS_MODE,
} from 'features/plc/contracts/pressHMI.schema';
import { usePLCValue, usePressTitle } from 'features/plc/providers/PLCProvider';
import React from 'react';

import HeatBlockStatus from '../components/heatBlockStatus';
import HeaterThermalStatus from '../components/heaterThermalStatus';
import OverrideControls from '../components/overrideControls';
import ProcessStatus from '../components/processStatus';
import SystemStatusAndControl from '../components/systemStatusAndControl';
import TemperaturePanel from '../components/temperaturePanel';

export default function ToolSwapContent() {
  const pressTitle = usePressTitle();
  const safeToSwapTool = usePLCValue(PLC_PATHS.status.safeToSwapTool);
  const toolSwapStabilizeRemaining = usePLCValue(PLC_PATHS.status.toolSwapStabilizeRemaining);

  return (
    <ContentLayout
      header={(
        <Header
          variant="h1"
          actions={(
            <PLCButton
              path={PLC_PATHS.cmd.pressMode}
              value={PRESS_MODE.NONE}
              variant="primary"
            >
              Disable cool down mode
            </PLCButton>
          )}
        >
          {pressTitle}
          {' - Cool Down'}
        </Header>
      )}
    >
      <SpaceBetween direction="vertical" size="l">
        {safeToSwapTool ? (
          <Alert type="success" header="Safe to swap tool">
            The press has cooled below 35 °C. You may safely remove and install the tool.
          </Alert>
        ) : (
          <Alert type="warning" header="Not safe to swap tool yet">
            Bringing temperature down to below 35 °C. Please wait before handling the tool.
            {toolSwapStabilizeRemaining > 0 ? (
              <>
                {' '}
                Stabilizing for
                {' '}
                {formatDuration(toolSwapStabilizeRemaining)}
                .
              </>
            ) : null}
          </Alert>
        )}
        <Grid gridDefinition={[{ colspan: 4 }, { colspan: 4 }, { colspan: 4 }]}>
          <TemperaturePanel side="upper" fields={[]} />
          <TemperaturePanel side="lower" fields={[]} />
          <ColumnLayout columns={2}>
            <ProcessStatus />
          </ColumnLayout>
        </Grid>

        <Grid
          gridDefinition={[
            { colspan: 6 }, { colspan: 6 },
          ]}
        >
          <HeaterThermalStatus />
          <SystemStatusAndControl />
        </Grid>

        <ExpandableSection headerText="Override controls" variant="container">
          <OverrideControls />
        </ExpandableSection>
        <ExpandableSection headerText="Heat block status" variant="container">
          <HeatBlockStatus />
        </ExpandableSection>
      </SpaceBetween>
    </ContentLayout>
  );
}
